import React from 'react';
import Webgear from './webgear.svg';
import Android from './android.svg';
import Apple from './apple.svg';
import Bitcoin from './bitcoin.svg';
import Caution from './caution.svg';
import Connection from './connection.svg';
import Cloud from './cloud.svg';
import Fingerprint from './fingerprint.svg';
import Fade from "react-reveal/Fade";
import './Assessment.css';
import Comp from './Comp/Comp';

const assessment = () => {
    return (
        <div className="assessment">
            <div className="container-fluid main-div">
                <h3 className="main">
                    <Fade top delay={300}>
                        <span className="content1">Our&nbsp;</span>
                        <span className="content2">Special Assessment</span>
                    </Fade>
                </h3>
                <Fade delay={300}>
                    <div className="row circle-row1">
                        <div className="column col-3">
                            <Comp className="class1" name="Web Application" src={Webgear} conname="Security" />
                        </div>
                        <div className="column col-3">
                            <Comp className="class2" name="Android Application" src={Android} conname="Security" />
                        </div>
                        <div className="column col-3">
                            <Comp className="class3" name="IOS Application" src={Apple} conname="Security" />
                        </div>
                        <div className="column col-3">
                            <Comp className="class4" name="Block Chain" src={Bitcoin} conname="Security" />
                        </div>
                    </div>
                </Fade>
                <Fade delay={300}>
                    <div className="row circle-row2">
                        <div className="column col-3">
                            <Comp className="class1" name="Governance" src={Caution} conname="Risk & Compliance" />
                        </div>
                        <div className="column col-3">
                            <Comp className="class2" name="Network" src={Connection} conname="Security" />
                        </div>
                        <div className="column col-3">
                            <Comp className="class3" name="IOT Security" src={Cloud} conname="Assessments" />
                        </div>
                        <div className="column col-3">
                            <Comp className="class4" name="Forensic" src={Fingerprint} conname="Investingation" />
                        </div>
                    </div>
                </Fade>
            </div>
        </div>
    )
}

export default assessment;